export default {
  data() {
    return {
      secure_img: require("@/assets/secure_img.png"),
      show_secur: false
    };
  },
  mounted() {
    // 判断是否是中文环境, 如果是中文环境就显示安全图标
    if (this.$i18n.locale == "zh") {
      this.show_secur = true;
    }
  },
  methods: {}
};